module.exports = __webpack_public_path__ + "img/KCC.3fea1906.png";